<template>
  <div>
    <section id="course-page" class="course-page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="content">
              <!-- <img :src="details.Pic2" /> -->
              <div class="header">
                <div>
                  <span>{{details.Name}}</span>
                  <div v-if="details.IsHot==1" class="hot">
                    <span><i class="iconfont icon-shandian-shi" style="font-size:14px;"></i>火热报名中</span>
                  </div>
                </div>
                <p v-html='details.Desc'></p>
              </div>
              <div class="content1">
                <span>专业</span>
                <el-button v-if="details.IsOpen==true" style="float:right" class="k-btn-primary lg" @click="onSubmit">立即报名</el-button>
                <el-button v-else style="float:right" class="k-btn-default lg">暂未开放</el-button>
                <div class="list">
                  <div class="item" v-for="(item, index) in details.CourseDetailsJobs" :key="index">
                    <div class="col-1">{{index+1}}</div>
                    <div class="col-9">
                      <span>{{item.Name}}</span>
                      <span v-if="item.Teachers">老师：<span>{{item.Teachers}}</span></span>
                    </div>
                    <div class="col-2">
                      <!-- 南昌隐藏三类特种继续教育专业报名费用 -->
                      <div v-if="!(projectName == 'NCJZJY' && (details.Id == 2 || details.Id == 4))">
                        <span>￥{{item.Price}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <!-- <div class="content1-right">
              <el-button class="k-btn normal" @click="onSubmit">立即报名</el-button>
              <div>
                <div><span>专业数</span><span>{{details.JobCount}}个专业</span></div>
                <div><span>平均课时数量</span><span>{{details.AvgJobLessonCount}}个课程</span></div>
                <div><span>平时总时长</span><span>{{details.AvgJobDuration/60}}小时</span></div>
              </div>
            </div> -->
            <component :is="newsView" ref="newsView"></component>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Vue, mapGetters, ProjectSettings } from '../base/base.js';
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      projectName: ProjectSettings.Name,
      queryModel: {
        Page: 1,
        PageSize: 6
      }
    }
  },
  computed: {
    ...mapGetters({
      details: 'getCourseDetails'
    })
  },
  created: function () {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/list'], resolve)
    });
  },
  mounted() {
    // 清除报名人员选中值
    this.$store.state.localModule.enrollstudent = [];
    this.$store.dispatch('getCourseDetails', { Id: this.$route.query.Id });
  },
  methods: {
    onSubmit() {
      let token = Cookies.get('Token');
      let userTypeId = Cookies.get('UserTypeId');
      if (token == null) {
        $('#loginModal').modal()
      } else if (userTypeId === '2') {
        let courseId = Number(this.$route.query.Id);
        if (this.projectName === 'NCJZJY' && _.indexOf([1, 3, 5, 7, 12], courseId) !== -1) {
          Cookies.set('isZhongYaoTongZhi', 'false');
        } else if (this.projectName === 'SRJZY') {
          Cookies.set('isZhongYaoTongZhi', 'false');
        }
        this.$router.push({ name: 'courseEnroll', query: { CourseId: this.$route.query.Id } });
      } else {
        this.$alert('请使用企业账号登录。', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
      };
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  > img {
    height: 400px;
    width: 100%;
  }
  .header {
    > div {
      // margin: 32px 0;
      display: flex;
      align-items: center;
      > span {
        font-size: 35px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 52px;
        letter-spacing: 1px;
        color: #333333;
      }
      .hot {
        height: 24px;
        line-height: 18px;
        background-color: #ff6715;
        border-radius: 4px;
        margin-left: 26px;
        padding: 2px 6px 2px 4px;
        span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
        }
      }
    }
    p {
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #777777;
      margin-bottom: 50px;
    }
  }
  .content1 {
    > span {
      font-size: 35px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 52px;
      letter-spacing: 1px;
      color: #333333;
      margin-bottom: 30px;
    }
    .list {
      display: flex;
      flex-direction: column;
      border: solid 1px #eaeaea;
      margin-top: 20px;
      .item {
        display: flex;
        flex-direction: row;
        height: 88px;
        & + .item {
          border-top: solid 1px #eaeaea;
        }
        .col-1 {
          font-size: 50px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 64px;
          letter-spacing: 1px;
          color: #eaeaea;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 0 0 120px;
          max-width: 120px;
        }
        .col-2 {
          align-items: center;
          justify-content: center;
          display: flex;
          flex: 0 0 140px;
          max-width: 140px;
          > div {
            width: 120px;
            height: 32px;
            background-color: #f7f7f7;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .col-9 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 0px;
          flex: 1;
          > span {
            font-size: 22px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            line-height: 30px;
            color: #333333;
            & + span {
              color: #777777;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              > span {
                color: #16cfd0;
              }
            }
          }
        }
      }
    }
  }
}

.content1-right {
  .k-btn {
    width: 100%;
  }
  > div {
    border-top: solid 1px #cccccc;
    margin-top: 40px;
    margin-bottom: 64px;
    > div {
      display: flex;
      justify-content: space-between;
      border-bottom: solid 1px #cccccc;
      line-height: 32px;
      span:nth-child(2) {
        font-weight: 600;
      }
    }
  }
}

.k-btn-default {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/home/course_details.vue